import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const NOT_THE_SAME_ACTIVITY_FRAGMENT = gql `
  fragment NotTheSameActivityFragment on NotTheSameActivity {
    rounds {
      steps {
        answer
        isLeft
        notTheSameOptionalImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default NOT_THE_SAME_ACTIVITY_FRAGMENT;
